!(function () {
    "use strict";

    class CartBar extends HTMLElement {
        constructor() {
            super();

            this.section = this.closest(".index-product");
            this.form = this.section?.querySelector("[data-product-form]");
            this.formWrapper =
                (theme.settings.productPageSticky &&
                    this.section?.querySelector("[data-form-wrapper]")) ||
                this.form;

            this.handleClick = this.handleClick.bind(this);
            this.handleProductAddSuccess = this.handleProductAddSuccess.bind(this);
            this.handleProductAddError = this.handleProductAddError.bind(this);
            this.boundToggleCartBarOnScroll = this.toggleCartBarOnScroll.bind(this);
            this.boundSetCartBarHeight = this.setCartBarHeight.bind(this);
        }

        connectedCallback() {
            this.setCartBarHeight();

            this.addEventListener("click", this.handleClick);

            document.addEventListener("theme:scroll", this.boundToggleCartBarOnScroll);
            document.addEventListener("theme:resize", this.boundSetCartBarHeight);
            document.addEventListener("theme:product:add", this.handleProductAddSuccess);
            document.addEventListener("theme:product:add-error", this.handleProductAddError);
        }

        handleClick(event) {
            const btn = event.target.closest("[data-cart-bar-add-to-cart]");

            if (btn) {
                event.preventDefault();

                btn.classList.add("is-loading");
                btn.setAttribute("disabled", "disabled");

                if (this.form) {
                    this.form.requestSubmit();
                }

                return;
            }

            const scrollBtn = event.target.closest("[data-cart-bar-scroll]");
            if (scrollBtn) {
                event.preventDefault();
                this.scrollToTop();
            }
        }

handleProductAddSuccess() {
    const btn = this.querySelector("[data-cart-bar-add-to-cart]");
    if (!btn) return;

    // Remove loading state
    btn.classList.remove("is-loading");
    btn.removeAttribute("disabled");

    // Add success tick class
    btn.classList.add("is-added");

    // Remove tick after 2 seconds (optional)
    setTimeout(() => {
        btn.classList.remove("is-added");
    }, 2000);
}
        handleProductAddError() {
            const btn = this.querySelector("[data-cart-bar-add-to-cart]");
            if (btn) {
                btn.classList.remove("is-loading");
                btn.removeAttribute("disabled");
            }

            this.scrollToTop();
        }

        scrollToTop() {
            const variantSelects = this.section?.querySelector("variant-selects");

            const targetTop = (
                window.theme.isMobile()
                    ? variantSelects || this.form
                    : this.section
            )?.getBoundingClientRect().top;

            if (typeof targetTop === "number") {
                window.theme.scrollTo(
                    window.theme.isMobile() ? targetTop - 10 : targetTop
                );
            }
        }

        toggleCartBarOnScroll() {
            if (!this.formWrapper) return;

            const shouldShow =
                window.scrollY >
                this.formWrapper.offsetTop + this.formWrapper.offsetHeight;

            this.classList.toggle("is-visible", shouldShow);
        }

        setCartBarHeight() {
            const height = this.offsetHeight;
            document.documentElement.style.setProperty(
                "--cart-bar-height",
                `${height}px`
            );
        }

        disconnectedCallback() {
            document.removeEventListener("theme:scroll", this.boundToggleCartBarOnScroll);
            document.removeEventListener("theme:resize", this.boundSetCartBarHeight);
            document.removeEventListener("theme:product:add", this.handleProductAddSuccess);
            document.removeEventListener("theme:product:add-error", this.handleProductAddError);
        }
    }

    if (!customElements.get("cart-bar")) {
        customElements.define("cart-bar", CartBar);
    }
})();
